import React from 'react';

//WARNING: do not wrapp withStyles HOC as displayName will not be preserved
const Header = ({ children, theme }) => {
  return(
    <div style={{
        flexGrow: 1,
        display: 'flex',
        marginBottom: theme.spacing.unit*2,
      }}>
      {children}
    </div>
  );
};

Header.displayName ="Header";

export default Header;



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/Header.jsx